var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4997 8.74999H8.74967C7.97613 8.74999 7.23426 9.05729 6.68728 9.60427C6.1403 10.1512 5.83301 10.8931 5.83301 11.6667V26.25C5.83301 27.0235 6.1403 27.7654 6.68728 28.3124C7.23426 28.8594 7.97613 29.1667 8.74967 29.1667H23.333C24.1066 29.1667 24.8484 28.8594 25.3954 28.3124C25.9424 27.7654 26.2497 27.0235 26.2497 26.25V17.5M16.0413 18.9583L29.1663 5.83333M29.1663 5.83333H21.8747M29.1663 5.83333V13.125",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external_link.a0c8703c08efc4d0010318a39c1b5199.svg";
export { ForwardRef as ReactComponent };